import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './quasar'


// FIREBASE


// Initialize Firebase with your configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDWILCwTkvnY8WIkreJcw996MmUoeu_SeY',
  authDomain: 'vuefire-88ba7.firebaseapp.com',
  databaseURL: 'https://vuefire-88ba7.firebaseio.com',
  projectId: 'vuefire-88ba7',
  storageBucket: 'vuefire-88ba7.appspot.com',
  messagingSenderId: '265521062607',
  appId: '1:265521062607:web:0f1e27a27637aa47'
};

import { initializeApp } from "firebase/app";
initializeApp(firebaseConfig);


import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);


import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBpfmnRNSves2ctFvLihU_9-t4_iRn-QeY',
    v: '3.26',
    libraries: 'places, drawing, visualization',  // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  autobindAllEvents: true,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})


  import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues
  Vue.component('google-map', VueGoogleMaps.Map);
  Vue.component('google-kml-layer', VueGoogleMaps.KmlLayer);
  Vue.component('GmapCluster', GmapCluster)


import sideBar from './components/sideBar.vue'
Vue.component('SideBar', sideBar);

import topBar from './components/topBar.vue'
Vue.component('topBar', topBar);

import ProgressLoading from './components/ProgressLoading.vue'
Vue.component('ProgressLoading', ProgressLoading);



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
